export default __webpack_public_path__ + "static/media/fallen kingdom (Gustixa Remix).9f82d81b.mp3";